import SkeletonBase, { SkeletonProps } from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"

import styles from "./Skeleton.module.scss"

export default function Skeleton(props: SkeletonProps) {
    return (
        <div className={styles.base}>
            <SkeletonBase {...props} />
        </div>
    )
}
